import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AuthHttp {
  constructor(private readonly http: HttpClient) {}

  createAuthorizationHeader() {
    return new HttpHeaders().set('Authorization', 'Bearer ' + localStorage.getItem('access_token'));
  }

  put<T = any>(url, data) {
    return this.http.put<T>(url, data, {
      headers: this.createAuthorizationHeader(),
    });
  }

  get<T = any>(url, params?: any) {
    return this.http.get<T>(url, {
      headers: this.createAuthorizationHeader(),
      params,
    });
  }

  getBlob(url, params?: any) {
    return this.http.get(url, {
      headers: this.createAuthorizationHeader(),
      params,
      responseType: 'blob',
    });
  }

  post<T = any>(url, data) {
    return this.http.post<T>(url, data, {
      headers: this.createAuthorizationHeader(),
    });
  }

  postProgress<T = any>(url, data) {
    return this.http.post<T>(url, data, {
      headers: this.createAuthorizationHeader(),
      reportProgress: true,
      observe: 'events',
    });
  }

  delete<T = any>(url, params?: any) {
    return this.http.delete<T>(url, {
      headers: this.createAuthorizationHeader(),
      params,
    });
  }

  patch<T>(url: string, data: any) {
    return this.http.patch<T>(url, data, {
      headers: this.createAuthorizationHeader(),
    });
  }

  patchEvents(url: string, data: any) {
    return this.http.patch(url, data, {
      headers: this.createAuthorizationHeader(),
      observe: 'events',
      reportProgress: true,
    }) as any as Observable<HttpEvent<any>>;
  }
}
